export default function CCodeBlocks() {
  return <h2>C Code Blocks</h2>;
}
